(function () {
  const CART_LABEL = 'Fotografia para personalização';
  const SELECTOR_FORM = 'form[action="/cart/add"]';
  const QTY_ID = 'Quantity-template--27888675586379__main';
  const ERROR_ID = 'mini-upload-error';
  const WARN_ID = 'mini-upload-warning';
  const OK_ID = 'mini-upload-ok';

  function getQuantity() {
    const el = document.getElementById(QTY_ID) || document.querySelector('input[name="quantity"]');
    return parseInt(el?.value || 1);
  }

  function getUploadedUrls(form) {
    const seen = new Set();
    return Array.from(form.querySelectorAll('input[type="hidden"]'))
      .filter(el => el.name.includes(CART_LABEL) && el.value)
      .filter(el => {
        if (seen.has(el.value)) return false;
        seen.add(el.value);
        return true;
      });
  }

  function showMessage(form, id, msg, style) {
    clearMessages();
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('p');
      el.id = id;
      el.style.cssText = style;
      const btn = form.querySelector('[type="submit"]');
      btn.parentNode.insertBefore(el, btn);
    }
    el.textContent = msg;
  }

  const styleRed   = 'color:red; font-weight:bold; font-size:1.2rem; margin-top:8px; padding:8px; border:1px solid red; border-radius:4px; background:#fff5f5;';
  const styleGreen = 'color:#155724; font-weight:bold; font-size:1.2rem; margin-top:8px; padding:8px; border:1px solid #28a745; border-radius:4px; background:#d4edda;';

  function clearMessages() {
    [ERROR_ID, WARN_ID, OK_ID].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.remove();
    });
  }

  function validate(e) {
    const form = e.target.closest(SELECTOR_FORM);
    if (!form) return;

    const qty = getQuantity();
    const uploads = getUploadedUrls(form);
    const count = uploads.length;

    // Cenário 1: sem nenhuma foto — bloqueia
    if (count === 0) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showMessage(form, ERROR_ID, 'Por favor carregue pelo menos uma fotografia antes de adicionar ao carrinho.', styleRed);
      return;
    }

    // Cenário 2: mais do que uma foto mas incompatível com a quantidade — bloqueia
    if (count > 1 && count !== qty) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const faltam = qty - count;
      if (faltam > 0) {
        showMessage(form, WARN_ID, `Carregou ${count} foto(s) para ${qty} azulejo(s). Por favor carregue mais ${faltam} foto(s) para que cada azulejo tenha a sua própria fotografia.`, styleRed);
      } else {
        const aMais = count - qty;
        showMessage(form, WARN_ID, `Carregou ${count} foto(s) para ${qty} azulejo(s). Por favor remova ${aMais} foto(s) ou aumente a quantidade de azulejos.`, styleRed);
      }
      return;
    }

    // Cenário 3: uma foto com vários azulejos — permite e informa
    if (count === 1 && qty > 1) {
      showMessage(form, OK_ID, `Carregou apenas 1 fotografia para ${qty} azulejo(s). Todos serão produzidos com a mesma fotografia.`, styleGreen);
      // Não bloqueia — deixa avançar
      return;
    }

    // Tudo OK (fotos == azulejos)
    clearMessages();
  }

  document.addEventListener('submit', validate, true);
})();
